export default "__VITE_ASSET__66d83f22__"